import { atom } from "recoil";

export const addStateRegion = atom({
  key: "addStateRegion",
  default: false,
});
export const editStateRegion = atom({
  key: "editStateRegion",
  default: false,
});
export const rowEditIdStateRegion = atom({
  key: "rowEditIdStateRegion",
  default: null,
});
export const disableButtonStateRegion = atom({
  key: "disableButtonStateRegion",
  default: false,
});

export const rowForEditStateRegion = atom({
  key: "rowForEditStateRegion",
  default: [],
});

export const selectedRowsStateRegion = atom({
  key: "selectedRowsStateRegion",
  default: [],
});

export const setFilterTextRegion = atom({
  key: "setFilterTextRegion",
  default: "",
});

export const setCheckStatusStateRegion = atom({
  key: "setCheckStatusStateRegion",
  default: false,
});

export const setLinkStateRegion = atom({
  key: "setLinkStateRegion",
  default: false,
});
export const setButtonLinkTextStateRegion = atom({
  key: "setButtonLinkTextStateRegion",
  default: "",
});

export const setHierarchyIdStateRegion = atom({
  key: "setHierarchyIdStateRegion",
  default: "",
});
export const setDescriptionRegionState = atom({
  key: "setDescriptionRegionState",
  default: "",
});
